// API 配置
// 开发环境使用相对路径（通过 vue.config.js 代理）
// 生产环境使用环境变量或完整 URL

const getApiBaseUrl = () => {
  // 开发环境：使用相对路径，通过代理转发
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  
  // 生产环境：使用环境变量或默认值
  // 如果设置了 VUE_APP_API_BASE_URL，使用它；否则使用 localhost:28080
  return process.env.VUE_APP_API_BASE_URL || 'https://james-backend.59337213.xyz';
};

export const API_BASE_URL = getApiBaseUrl();
export const API_TOKEN = process.env.VUE_APP_API_TOKEN || 'tEem66eue6zMwKo1Jn30rQ==';

// 构建完整的 API URL
export const buildApiUrl = (path) => {
  const baseUrl = API_BASE_URL;
  // 确保路径以 / 开头
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  
  if (baseUrl) {
    // 如果设置了基础 URL，拼接完整路径
    return `${baseUrl}${normalizedPath}`;
  }
  
  // 否则返回相对路径（开发环境通过代理，生产环境如果是同域也可以）
  return normalizedPath;
};

